import { shouldAnimate, readEnv, loadGsap, whenNear } from './gm-motion.js';
const heat = document.querySelector('[data-gm-heat]');
if (heat && shouldAnimate(readEnv())) whenNear(heat, async () => {
  const { gsap } = await loadGsap().catch(() => ({}));
  if (!gsap) return; // static fallback CSS (--heat: 60%) stands as-is
  const swap = heat.querySelector('.gm-swap'), hot = heat.querySelector('.hot'), temp = heat.querySelector('[data-gm-temp]');
  if (!swap || !hot) return;
  heat.classList.add('is-live');
  gsap.to(hot, {
    '--heat': '75%', ease: 'none',
    scrollTrigger: {
      trigger: swap, start: 'top 80%', end: 'bottom 40%', scrub: true,
      // 25°F → 93°F as the scroll scrubs the heat in
      onUpdate: (s) => { if (temp) temp.textContent = (25 + Math.round(s.progress * 68)) + '°F'; },
    },
  });
});
